import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcPeopleColor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 34,
	height: 34,
	viewBox: "0 0 34 34",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.7857 10.9314C15.7857 13.6139 13.6111 15.7885 10.9286 15.7885C8.24606 15.7885 6.07145 13.6139 6.07145 10.9314C6.07145 8.24884 8.24606 6.07422 10.9286 6.07422C13.6111 6.07422 15.7857 8.24884 15.7857 10.9314Z",
			fill: "#6C9CFA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.9286 10.9314C27.9286 13.6139 25.754 15.7885 23.0714 15.7885C20.3889 15.7885 18.2143 13.6139 18.2143 10.9314C18.2143 8.24884 20.3889 6.07422 23.0714 6.07422C25.754 6.07422 27.9286 8.24884 27.9286 10.9314Z",
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.42859 20.6456C2.42859 18.6338 4.05955 17.0028 6.07145 17.0028H15.7857C17.7976 17.0028 19.4286 18.6338 19.4286 20.6456V26.7171C19.4286 27.3877 18.8849 27.9314 18.2143 27.9314H3.64288C2.97224 27.9314 2.42859 27.3877 2.42859 26.7171V20.6456Z",
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5714 20.6456C14.5714 18.6338 16.2024 17.0028 18.2143 17.0028H27.9286C29.9405 17.0028 31.5714 18.6338 31.5714 20.6456V26.7171C31.5714 27.3877 31.0278 27.9314 30.3572 27.9314H15.7857C15.1151 27.9314 14.5714 27.3877 14.5714 26.7171V20.6456Z",
			fill: "#6C9CFA"
		})
	]
});
export default SvgIcPeopleColor;
